import { useCallback } from "react";
import { useWidget } from "../context/WidgetContext";
import { Widget } from "../types";


export const useWidgetActions = () => {
    const { dispatch } = useWidget();

    const setWidgets = useCallback(
        (widgets: Widget[]) => {
            dispatch({ type: "SET_CURRENT_WIDGETS", payload: widgets });
        },
        [dispatch]
    );

    const addWidget = useCallback(
        (widget: Widget) => {
            dispatch({ type: "ADD_WIDGET", payload: widget });
        },
        [dispatch]
    );

    const updateWidget = useCallback(
        (widget: Widget) => {
            dispatch({ type: "UPDATE_WIDGET", payload: widget });
        },
        [dispatch]
    );
    const deleteWidget = useCallback(
        (widgetId: number) => {
            dispatch({ type: "DELETE_WIDGET", payload: widgetId });
        },
        [dispatch]
    );

    const setLoading = useCallback(
        (loading: boolean) => {
            dispatch({ type: "SET_LOADING", payload: loading });
        },
        [dispatch]
    );

    const setError = useCallback(
        (error: string | null) => {
            dispatch({ type: "SET_ERROR", payload: error });
        },
        [dispatch]
    );

    return {
        setWidgets,
        addWidget,
        updateWidget,
        deleteWidget,
        setLoading,
        setError,
    };
};
